import React from 'react';
import { Route, Switch } from 'react-router-dom';

import RoleMenu from './components/RoleMenu.jsx';
import TabMenu from './components/TabMenu.jsx';
import TeamSignup from './components/TeamSignup.jsx';
import ConfirmationScreen from './components/ConfirmationScreen.jsx';
import DriverSelfRatingsMenu from './components/DriverSelfRatingsMenu.jsx';
import DriverSelfRatingsTrackTypeMenu from './components/DriverSelfRatingsTrackTypeMenu.jsx';
import DriverSelfRatingsSessionMenu from './components/DriverSelfRatingsSessionMenu.jsx';
import Training from './components/forms/Training.jsx';
import DriverRatingsMenu from './components/DriverRatingsMenu.jsx';
import FormRatingSelfWrapper from './components/forms/FormRatingSelfWrapper.jsx';
import FormRatingWrapper from './components/forms/FormRatingWrapper.jsx';
import Partners from './components/Partners.jsx';
import Practice from './components/forms/Practice.jsx';
import News from './components/News.jsx';
import Qualifying from './components/forms/Qualifying.jsx';
import Race from './components/forms/Race.jsx';
import Reflection from './components/forms/Reflection.jsx';
import Dirt from './components/forms/Dirt.jsx';
import OnTrack from './components/forms/OnTrack.jsx';
import OffTrack from './components/forms/OffTrack.jsx';
import Simulator from './components/forms/Simulator.jsx';
import NotFound from './components/NotFound.jsx';

import helpers from './lib/helpers';

const redirectToHomeIfOnMobile = (nextState, replace, callback) => {
  if (helpers.isMobile()) replace('/');
  callback();
};

export default (
  <Switch>
    <Route exact path="/" component={RoleMenu} />

    <Route exact path="/signup/driver" component={TabMenu} onEnter={redirectToHomeIfOnMobile}></Route>
    <Route exact path="/signup/team-member" component={TeamSignup} onEnter={redirectToHomeIfOnMobile}></Route>

    {/* <Route exact path="/rating/self" component={DriverSelfRatingsMenu}></Route> */}

    <Route exact path="/rating/self" component={DriverSelfRatingsMenu}></Route>
    <Route exact path="/rating/self/track-type" component={DriverSelfRatingsTrackTypeMenu}></Route>
    <Route exact path="/rating/self/session" component={DriverSelfRatingsSessionMenu}></Route>
    <Route exact path="/rating/self/training" component={FormRatingSelfWrapper(Training, 'training')}></Route>

    <Route exact path="/rating/self/practice" component={FormRatingSelfWrapper(Practice, 'practice')}></Route>
    <Route exact path="/rating/self/qualifying" component={FormRatingSelfWrapper(Qualifying, 'qualifying')}></Route>
    <Route exact path="/rating/self/race" component={FormRatingSelfWrapper(Race, 'race')}></Route>
    <Route exact path="/rating/self/reflection" component={FormRatingSelfWrapper(Reflection, 'reflection')}></Route>

    <Route exact path="/rating/self/dirt" component={FormRatingSelfWrapper(Dirt, 'dirt')}></Route>
    <Route exact path="/rating/self/track-type" component={DriverSelfRatingsTrackTypeMenu}></Route>

    <Route exact path="/rating/driver" component={() => (<DriverRatingsMenu isMobile={helpers.isMobile()} />)}></Route>

    <Route exact path="/rating/driver/on-track" component={FormRatingWrapper(OnTrack, 'on')}></Route>
    <Route exact path="/rating/driver/off-track" component={FormRatingWrapper(OffTrack, 'off')}></Route>
    <Route exact path="/rating/driver/simulator" component={FormRatingWrapper(Simulator, 'simulator')}></Route>

    <Route exact path="/partners" component={Partners}></Route>
    <Route exact path="/news" component={News}></Route>

    <Route exact path="/confirmation/:type" component={ConfirmationScreen}></Route>

    <Route exact path="*" component={NotFound}></Route>
  </Switch>
);
